import { BaseService } from 'shared/services/BaseService';
import { Option } from 'shared/types/general';

class ExamTagService extends BaseService<Option> {
  constructor() {
    super('exam-tags');
  }
}

export const examTagService = new ExamTagService();
